<template>
    <module-card>
        <p>
            For some of us, good communication comes really naturally and for others it’s more challenging. From the list below, select what <strong>YOU</strong> think should be the order of the tips you’d tell P for good, effective and
            “assertive,” <strong>spoken communication</strong> – especially when he’s worked up! Assertive communication means letting the other person know what you want in an active and appropriate way.
        </p>
        <p>
            <strong
                >Reorder the tips below, starting with the one that is most important for YOU. In order to re-order the tips, click on the tip you want to move, then click on the space you would like to move it to. Once you’ve got them in
                your preferred order, tap Next.</strong
            >
        </p>

        <transition-group name="sort-list" tag="div">
            <v-row
                align="center"
                v-for="(step, index) in shuffledStepsOrder"
                :key="step.order"
                class="grey lighten-3 px-2 ml-3 mb-1"
                :class="{ info: index === selectedIndex, available: isAvailable(step.order, index) }"
                @click="click(step.order, index)"
            >
                <v-col cols="1" class="ordinal" :class="{ 'info--text': isAvailable(step.order, index) }">
                    <div>{{ index + 1 }}</div>
                </v-col>
                <v-col>{{ step.step }}</v-col>
            </v-row>
        </transition-group>
    </module-card>
</template>

<script>
    import { shuffle } from 'lodash';

    export default {
        data() {
            return {
                steps: [
                    {
                        order: 1,
                        step: 'Knowing what you’re asking for and making it clear (keeping the “uh,” “what-do-you-call-its,” “like…” and “ums” to a minimum”)'
                    },
                    {
                        order: 2,
                        step: 'Being clear, and NOT just hoping the other person will figure out what’s on your mind.'
                    },
                    {
                        order: 3,
                        step: 'Being direct and honest in how to speak to people (use “I” statements, such as “I feel…” or “I think…”)'
                    },
                    {
                        order: 4,
                        step: 'Having a clear and articulate voice (NOT yelling, mumbling, or overusing the “f-word” or other swearing)'
                    }
                ],
                selectedIndex: null,
                shuffledStepsOrder: []
            };
        },
        mounted() {
            this.shuffledStepsOrder = shuffle(this.steps);
        },
        methods: {
            isAvailable(key, index) {
                return this.selectedIndex !== null && this.selectedIndex !== index;
            },
            click(key, index) {
                if (this.selectedIndex !== null) {
                    const a = this.shuffledStepsOrder[this.selectedIndex];
                    const b = this.shuffledStepsOrder[index];
                    this.shuffledStepsOrder.splice(this.selectedIndex, 1, b);
                    this.shuffledStepsOrder.splice(index, 1, a);

                    this.selectedIndex = null;
                } else {
                    this.selectedIndex = index;
                }
            }
        }
    };
</script>

<style scoped>
    .ordinal {
        margin-left: -3em;
        padding-right: 2em;
        width: 2em;
    }
    .ordinal div {
        font-weight: bold;
        width: 20px;
        margin-left: -2px;
        text-align: center;
    }
    .available {
        box-shadow: 0 0 0 1px inset #0091ff;
        opacity: 0.75;
    }
    .sort-list-move {
        transition: transform 1s;
    }
</style>
